// extracted by mini-css-extract-plugin
module.exports = {"hidden":"badge_hidden__1DZA1","textEmphasis":"badge_textEmphasis__3vevS","badge":"badge_badge__2ncS2"};